import React, { useReducer, useEffect, useState } from "react";
import bannerpic from "../../assets/images/bannerpic.jpg";
import icon_1 from "../../assets/images/icon_1.svg";
import icon_2 from "../../assets/images/icon_2.svg";
import icon_3 from "../../assets/images/icon_3.svg";
import "./Home.css";

import news1 from "../../assets/images/home/news1.png";
import news2 from "../../assets/images/home/news2.png";
import styles from "./Home.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function hoverReducer(state, action) {
  switch (action.type) {
    case "enter1":
      return { ...state, bg1: "#DFE1E3" };
    case "leave1":
      return { ...state, bg1: "#f0f0f0" };
    case "enter2":
      return { ...state, bg2: "#DFE1E3" };
    case "leave2":
      return { ...state, bg2: "#f0f0f0" };
    default:
      console.log("None of the hover action match");
  }
}
const Home = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [hoverState, hoverDispatch] = useReducer(hoverReducer, {
    bg1: "#f0f0f0",
    bg2: "#f0f0f0",
  });
  const [newsList, setNewsList] = useState([]);
  console.log("BACKEND API LINK for news IS:");
  console.log(backend_base + "/home/news");
  useEffect(() => {
    axios
      .get(backend_base + "/home/news")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Latest 2 news");
          console.log(res.data);
          setNewsList(res.data);
        } else {
          console.log("Failed Getting news");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  return (
    <div className="home">
      <div className="home_banner">
        <div className="banner_text">今とミライを、つなげる場所</div>
      </div>
      <div className="home_options_box_main">
        <div className="home_options_box">
          <div
            onClick={() => {
              navigate("/gallery-front");
            }}
            className="home_gallery_box_main"
          >
            <div className="home_box_top_header01">データをダウンロード</div>
            <div className="home_box_header02_main">
              <img className="gallery_icon_1" src={icon_1} alt="not found" />
              <div className="home_box_header02_title">Gallery</div>
            </div>
          </div>

          <div className="home_design_box_main_wrapper">
            <div
              onClick={() => {
                navigate("/design-box");
              }}
              className="home_design_box_main"
            >
              <div className="home_design_top_header01">アイテムを編集</div>
              <div className="home_box_header02_main">
                <img className="design_icon_1" src={icon_2} alt="not found" />
                <div className="home_designbox_header02_title">Design</div>
              </div>
            </div>
          </div>

          <div
            onClick={() => {
              navigate("/onlineshop");
            }}
            className="home_shop_box_main"
          >
            <div className="home_shop_box_top_header01">アイテムを購入</div>
            <div className="home_shopbox_header02_main">
              <img className="shop_icon_1" src={icon_3} alt="not found" />
              <div className="home_shopbox_header02_title">Onlineshop</div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.home_desc_main}>
        <div className={styles.home_desc_heading01}>What is “My Ace”</div>
        <div className={styles.home_desc_02}>マイエースでできること</div>
        <div className={styles.home_desc_bottom_main}>
          <div>「一瞬をもっと素敵に」</div>
          <div>
            私たちは、ご家族にとってかけがえのない瞬間を大切に撮影させていただいています。
          </div>
          <div>
            今しかないこの瞬間を、ずっと「ミライ」へ残していただきたい。
          </div>
          <div>
            {" "}
            My Aceでは、写真をカタチとして残すアイテムのお買い物はもちろん、
          </div>
          <div>
            ご購入いただいたアイテムの編集をゆっくりとお楽しみいただけます。
          </div>
          <div> 撮影したデータをずっと保管しておくことも可能です。</div>
          <div> ゆっくりとMy Aceでの時間をお楽しみください。</div>
        </div>
        <div
          onClick={() => {
            navigate("/usage-flow");
          }}
          className={styles.button1}
        >
          ご利用の流れ
        </div>
      </div>

      <div className={styles.bottom_main_wrapper}>
        <div className={styles.bottom_main}>
          <div className={styles.bottom_main_header}>News</div>
          <div className={styles.bottom_main_news}>
            {Array.isArray(newsList) &&
              newsList.length > 0 &&
              newsList.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={styles.bottom_main_img_div}
                    onMouseEnter={() => {
                      hoverDispatch({ type: "enter" + (index + 1) });
                    }}
                    onMouseLeave={() => {
                      hoverDispatch({ type: "leave" + (index + 1) });
                    }}
                    onClick={() => {
                      navigate("/news-single/" + item.id);
                    }}
                  >
                    <img
                      src={backend_base + item.image}
                      className={styles.bottom_main_img}
                      alt="news1"
                    />
                    <div
                      style={{
                        backgroundColor:
                          index === 0 ? hoverState.bg1 : hoverState.bg2,
                      }}
                      className={styles.bottom_main_img_header}
                    >
                      {item.title}
                    </div>
                  </div>
                );
              })}
            {/* <div
              className={styles.bottom_main_img_div}
              onMouseEnter={() => {
                hoverDispatch({ type: "enter" + 1 });
              }}
              onMouseLeave={() => {
                hoverDispatch({ type: "leave" + 1 });
              }}
            >
              <img src={news1} className={styles.bottom_main_img} alt="news1" />
              <div
                style={{ backgroundColor: hoverState.bg1 }}
                className={styles.bottom_main_img_header}
              >
                全品10％OFFキャンペーン
              </div>
            </div>
            <div
              onMouseEnter={() => {
                hoverDispatch({ type: "enter" + 2 });
              }}
              onMouseLeave={() => {
                hoverDispatch({ type: "leave" + 2 });
              }}
              className={styles.bottom_main_img_div}
            >
              <img src={news2} className={styles.bottom_main_img} alt="news1" />
              <div
                style={{ backgroundColor: hoverState.bg2 }}
                className={styles.bottom_main_img_header}
              >
                敬老の日キャンペーン
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
